import type { ProcessDraftStep } from '@bliks-io/contracts';
import { collectDownstreamOf, currentSuccessorStatus } from './edge-actions/shared';

/**
 * Whether the "Mark as end" context-menu item should appear for a task step.
 *
 * Visible iff: (a) the target is a task step (decisions are scoped out — users
 * mark per-rule ends via the side panel), (b) no other step has an input
 * sourced from this step, and (c) the current successorStatus isn't already
 * 'NONE' (which would make the click a no-op since the synthetic end node
 * already renders).
 */
export function canMarkAsEnd(stableStepId: string, steps: readonly ProcessDraftStep[]): boolean {
  const target = steps.find((s) => String(s.stableStepId) === stableStepId);
  if (!target) return false;

  // `actionType` alone is authoritative — a task step keeps its inactive
  // `rules` subdoc across a toggle.
  if (target.actionType === 'decision') return false;

  if (currentSuccessorStatus(target, undefined) === 'NONE') return false;

  return collectDownstreamOf(stableStepId, [...steps], stableStepId).length === 0;
}
